module.exports = __webpack_public_path__ + "static/media/close.be85a997.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/close.svg
// module id = 45
// module chunks = 0